import React from 'react'
import { useSelector } from 'react-redux';

function Message({ message , sameUser}) {
    const username = useSelector(state => state.username);
    let outputMessage;
    let userInfo =<></>;

    if(!sameUser){
        userInfo = <h3>@{message.user} <div className="round"></div>{message.date}</h3>
    }

    if( message.user === "admin"){
        outputMessage = <div className = "admin-message">
            <h3>{message.message}</h3>
        </div>
    }
    else{
        outputMessage = (
            <div className={`message-container 
                ${username === message.user ? "message-right" : "message-left"}`}>
                <div className="message">
                    {userInfo}
                    <h2>{message.message}</h2>
                </div>
            </div>
        )
    }
    return outputMessage    
}

export default Message
